import { useQuery } from '@apollo/client'
import { NotificationsCountInboxNotificationsDocument } from 'generated/resources/graphql'

export const useUnreadNotificationCount = () => {
  const { loading, data, refetch } = useQuery(NotificationsCountInboxNotificationsDocument, {
    fetchPolicy: 'network-only',
    variables: {
      onlyUnread: true,
    },
  })

  const count = data?.notifications.inboxNotificationsConnection.totalCount ?? undefined
  const hasUnreadNotifications = !!count

  return {
    count,
    hasUnreadNotifications,
    loading,
    refetch,
  }
}
